// Interfaces
import { Column } from '../interfaces/Columns';

// Custom hook that handles a a search in a table. It receives a column array.
// The useSearchbar hook returns a function whose type is:
//    - (value: string) => () => (element: T) => boolean
//    - The function receives a string with the value of the searchbar input, and returns
//    a function that returns another function with a generic element (one of the given in 
//    the columns as input) and an execution of the hasCoincidence function.

const useSearchbar = <T,>(columns: Column<T>[]):
    (value: string) =>
        () => (element: T) => boolean => {

    const getFilter = (value: string) => {
        // Filters the elements that have a visible column with a coincidence 
        // with the input types by the user.
        const filteredColumns = columns.filter(column => column.visible);

        const filterSearchbar = () => {
            const hasCoincidence = (element: T) => {
                let foundString = false;
                filteredColumns.forEach(column => {
                    if (column.cell?.(element).toLocaleLowerCase().includes(value.toLocaleLowerCase())) {
                        foundString = true;
                    }
                });
                return foundString;
            };
            return (element: T) => hasCoincidence(element);
        };

        return filterSearchbar;
    };

    return getFilter;
};

export default useSearchbar;